<template>
  <div>
    <h1>Trend</h1>
    <table>
      <thead>
        <tr>
          <th style="text-align: right; padding-right: 3rem;">Category</th>
          <th>Quota</th>
          <th>90</th>
          <th>60</th>
          <th>30</th>
          <th>7</th>
          <th>Today</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="category in orderedCategories" :key="category">
          <td>
            <div class="flexRow category-label">
              {{ categories[category].name }}
              <static-block-row :color="categories[category].color" :completed="1" :quota="1" size="small" />
            </div>
          </td>
          <td>{{ Math.round(getAverageDailyQuota(category) * 10) / 10 }}</td>
          <td
            v-for="(average, i) in getCategoryAverages(category)"
            :key="`${i}${category}`"
            :style="`background-color: ${getBackgroundStyle(category, average)}`"
          >
            {{ Math.round(average.average * 10) / 10 }}
            <i
              v-if="average.range === 1"
              class="material-icons quota-status"
              :class="quotaStatusIcon(category, average)"
              >{{ quotaStatusIcon(category, average) }}</i
            >
            <div v-else class="impact-today">
              <i class="material-icons impact-icon" :class="impactStatusIcon(getDayImpact(category, average))">
                {{ impactStatusIcon(getDayImpact(category, average)) }}
              </i>
              {{ getDayImpact(category, average) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div></div>
  </div>
</template>

<script>
import db from "../db";
import util from "../util";
import categoryUtil from "../categoryUtil";

import StaticBlockRow from "../components/StaticBlockRow.vue";

export default {
  name: "TrendView",
  components: {
    StaticBlockRow,
  },
  props: ["categories"],
  data() {
    return {
      summaries: {},
    };
  },
  computed: {
    orderedCategories() {
      let ordered = [];
      Object.keys(this.categories).forEach(k => ordered.push(this.categories[k]));
      ordered.sort((a, b) => {
        //FIXME - This should be done elsewhere, please!
        a.orderImportance = a.orderImportance ? a.orderImportance : 0;
        b.orderImportance = b.orderImportance ? b.orderImportance : 0;
        if (a.orderImportance < b.orderImportance) {
          return 1;
        }
        if (a.orderImportance > b.orderImportance) {
          return -1;
        }
        return 0;
      });

      const final = [];
      ordered.forEach(category => {
        if (!category.parentId) {
          final.push(category.id);
        }
        if (category.showChildren) {
          Object.keys(category.children || {}).forEach(k => final.push(k));
        }
      });

      return final;
    },
  },
  methods: {
    getCategoryAverages(categoryId) {
      const ranges = [90, 60, 30, 7, 1];
      const averages = [];

      // So sorry... but it's not worth the time to optimize right now
      ranges.forEach(numDays => {
        const startDate = moment().subtract(numDays - 1, "days");
        let total = 0;
        for (let i = 0; i < numDays; i++) {
          try {
            const count = this.summaries[startDate.format("YY")][startDate.format("MM")][startDate.format("DD")][
              categoryId
            ];
            total += count || 0;
          } catch (e) {
            // LOL THIS IS HACK
          }
          startDate.add(1, "days");
        }
        averages.push({ range: numDays, average: total / numDays });
      });

      // IF CATEGORY !SHOWINGCHILDREN, TALLY EVERYTHING PLEASE
      if (!this.categories[categoryId].showChildren) {
        const children = Object.keys(this.categories[categoryId].children || {});
        children.forEach(childId => {
          const childAverages = this.getCategoryAverages(childId);
          for (let i = 0; i < childAverages.length; i++) {
            averages[i].average += childAverages[i].average;
          }
        });
      }

      return averages;
    },
    getAverageDailyQuota(categoryId) {
      const category = this.categories[categoryId];
      let dailyQuota = (category.quota * (category.activeDays || []).length) / 7;
      if (!category.showChildren) {
        Object.keys(category.children || {}).forEach(childId => {
          const child = this.categories[childId];
          dailyQuota += (child.quota * (child.activeDays || []).length) / 7;
        });
      }
      return dailyQuota;
    },
    getPercentOfQuota(categoryId, average) {
      let quota;
      if (average.range === 1) {
        quota = categoryUtil.getQuota(categoryId, util.getCurrentDay(), !this.categories[categoryId].showChildren);
        // quota = categoryUtil.getQuota(categoryId, util.getCurrentDay(), true);
      } else {
        quota = this.getAverageDailyQuota(categoryId);
      }

      return average.average / quota;
    },
    getBackgroundStyle(categoryId, average) {
      const percentage = this.getPercentOfQuota(categoryId, average);
      if (percentage < 1) {
        return `rgba(255, 0, 0, ${Math.min(1 - percentage, 0.5)});`;
      } else {
        return `rgba(0, 255, 0, ${Math.min(percentage - 1, 0.5)});`;
      }
    },
    quotaStatusIcon(categoryId, average) {
      const quota = categoryUtil.getQuota(categoryId, util.getCurrentDay(), !this.categories[categoryId].showChildren);
      if (quota === 0) {
        return "";
      }
      // "close" is another option here if we decide we want that look...
      return average.average >= quota ? "check" : "";
    },
    // TODO - Make this the delta between periods - just just the impact today has had?
    getDayImpact(categoryId, average) {
      const completedToday = categoryUtil.getCompleted(
        categoryId,
        util.getCurrentDay(),
        !this.categories[categoryId].showChildren
      );

      const totalCompleted = average.range * average.average;

      const previousAverage = (totalCompleted - completedToday) / (average.range - 1);
      return Math.round(100 * (average.average - previousAverage)) / 100;
    },
    impactStatusIcon(impact) {
      if (impact === 0) {
        return "";
      }
      return impact < 0 ? "keyboard_arrow_down" : "keyboard_arrow_up";
    },
  },
  async created() {
    this.summaries = await db.loadSummaryLastNDays(90);
  },
};
</script>

<style scoped>
.category-label {
  justify-content: flex-end;
}

table {
  margin: auto;
}

th {
  min-width: 4rem;
}

.quota-status {
  position: absolute;
  font-size: 1.25rem;
  margin-top: 0.75rem;
  margin-left: 0.375rem;
}

.quota-status.check {
  color: rgba(0, 255, 0, 0.75);
}
.quota-status.close {
  color: rgba(255, 0, 0, 0.75);
}

.impact-today {
  font-size: 0.75rem;
}

.impact-icon {
  font-size: 0.75rem;
  font-weight: bold;
  position: relative;
  top: 2px;
}

.impact-icon.keyboard_arrow_down {
  color: red;
}
.impact-icon.keyboard_arrow_up {
  color: green;
}
</style>



// WEBPACK FOOTER //
// TrendView.vue?b061ed10